const constants = {
  valueGuideLookUp: 'Value Guide Look up',
  submit: 'Submit',
  signIn: 'Sign In',
  dynamicLoans: 'Dynamic Loans',
  userName: 'UserName',
  paymentCalculator: 'Payment calculator',
  lookUp: 'Value Guide',
  program: 'Program',
  term: 'Term',
  promotion: 'Promotion',
  rate: 'Rate',
  balloonPayment: 'Balloon payment',
  contractDate: 'Contract date',
  amountFinanced: 'Itemization of amount financed',
  insurance: 'Insurance',
  fees: 'Fees',
  deferredPayment: 'Deferred payment',
  paymentSchedule: 'Payments Schedule',
  distributedData: 'Distributed Data',
};

export default constants;
